define.alias("shared/components/shared/pre-boarding/auto-trial-start/index", "preview-grid/components/shared/pre-boarding/auto-trial-start/index");